import axios from "axios";
import secureLocalStorage from "react-secure-storage"; 

//export const baseURL = "https://next-api.heckercare.com/api/v1"; // backend url
export const baseURL = "https://snext-api.heckercare.com/api/v1";
//export const baseURL = "http://localhost:8080/api/v1";

const client = axios.create({ baseURL });
let cancelToken;
export const request = async ({ ...options }) => {
  const userData = secureLocalStorage.getItem("hms_user");

  if (userData) {
    const { token } = userData;
    client.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  //client.defaults.headers["Access-Control-Allow-Origin"] = "*";

  //Check if there are any previous pending requests
  if (typeof cancelToken != typeof undefined && !options?.avoidCancelling) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  const { avoidCancelling, ...requestOptions } = options || {};
  //Save the cancel token for the current request
  cancelToken = axios.CancelToken.source();

  try {
    const response = await client({
      ...requestOptions,
      cancelToken: cancelToken.token,
    });

    return response;
  } catch (error) {
    let err = { ...error };
    if (error?.response?.data?.message)
      err = { ...error, message: error?.response?.data?.message };

    throw err;
  }
};